import React from 'react';

export const AlignCenter = () => (
    <g>
        <path d='M23.5,23h-23C0.224,23,0,23.224,0,23.5S0.224,24,0.5,24h23c0.276,0,0.5-0.224,0.5-0.5S23.776,23,23.5,23z' />
        <path d='M2.5,3h19C21.776,3,22,2.776,22,2.5S21.776,2,21.5,2h-19C2.224,2,2,2.224,2,2.5S2.224,3,2.5,3z' />
        <path d='M18,6c0.276,0,0.5-0.224,0.5-0.5S18.276,5,18,5H6C5.724,5,5.5,5.224,5.5,5.5S5.724,6,6,6H18z' />
        <path d='M3,8.5C3,8.776,3.224,9,3.5,9h17C20.776,9,21,8.776,21,8.5S20.776,8,20.5,8h-17C3.224,8,3,8.224,3,8.5z' />
        <path d='M0.5,12h23c0.276,0,0.5-0.224,0.5-0.5S23.776,11,23.5,11h-23C0.224,11,0,11.224,0,11.5S0.224,12,0.5,12z' />
        <path d='M19.5,14h-15C4.224,14,4,14.224,4,14.5S4.224,15,4.5,15h15c0.276,0,0.5-0.224,0.5-0.5S19.776,14,19.5,14z' />
        <path d='M17,18c0.276,0,0.5-0.224,0.5-0.5S17.276,17,17,17H7c-0.276,0-0.5,0.224-0.5,0.5S6.724,18,7,18H17z' />
        <path d='M4,20.5C4,20.776,4.224,21,4.5,21h15c0.276,0,0.5-0.224,0.5-0.5S19.776,20,19.5,20h-15C4.224,20,4,20.224,4,20.5z' />
    </g>
);